import request from '@/utils/request'
const tpm = 'tpm/'
const checklists = 'tpm_checklists/'
const checklist = 'tpm_checklist/'

// 获取tpm工单列表
export function getTpmChecklists(listQuery) {
  return request({ url: `${tpm}${checklists}`, method: 'GET', params: listQuery })
}

// 获取工单详情
export function getTaskChecklistDetail(templateId, listQuery) {
  return request({ url: `${tpm}${checklist}${templateId}`, method: 'GET', params: listQuery })
}
